/** When your routing table is too long, you can split it into small modules**/


export default [{
  path: '/cycles',
  name: 'Cylces',
  component: () => import('@/views/cycles/Index'),
},
{
  path: '/open-cycles',
  name: 'OpenCycles',
  component: () => import('@/views/cycles/Open'),
},
{
  path: '/exams',
  name: 'Exams',
  component: () => import('@/views/exams/Index'),
},
{
  path: '/gheibat',
  name: 'Gheibat',
  component: () => import('@/views/cycles/Gheibat'),
},
{
  path: '/gheibatSingle',
  name: 'GheibatSingle',
  component: () => import('@/views/cycles/GheibatSingle'),
}
]
